import { render } from "./Comment.vue?vue&type=template&id=2e74b0dc"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=2e74b0dc&lang=css"
script.render = render

export default script